import React, { useState, useCallback, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Table from 'react-bootstrap/Table';

const MyVerticallyCenteredModal = ({ validNameEmpresa, permissions, units, show, handleChangeChartModal, onHide }) => {

  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    const idsSet = new Set();
    const initialSelections = units.reduce((acc, company) => {
      if (!idsSet.has(company._id)) {
        idsSet.add(company._id);
        acc.push({
          _id: company._id,
          pp: typeof company.pp === "number" ? company.pp : 0
        });
      }
      return acc;
    }, []);

    setSelectedOptions(initialSelections);
  }, [units]);


  const handleSelectionChange = useCallback((companyId, value) => {
    const numericValue = typeof value === "number" ? value : parseFloat(value);

    setSelectedOptions((prevState) => {
      const exists = prevState.some(item => item._id === companyId);

      if (exists) {
        return prevState.map(item =>
          item._id === companyId ? { ...item, pp: numericValue } : item
        );
      }

      return [...prevState, { _id: companyId, pp: numericValue }];
    });
  }, []);


  const handleSave = () => {
    handleChangeChartModal(selectedOptions);
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen
      show={show}
      onHide={onHide}
      className="modal-dark"
    >
      <Modal.Header
        closeButton
        className="border-0"
        style={{
          background: "rgba(15, 23, 42, 0.98)",
          color: "#e5e7eb"
        }}
      >
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="fw-semibold"
        >
          Selecionar Preferências
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="text-white"
        style={{
          background: "radial-gradient(circle at top, #020617 0, #020617 40%, #000000 100%)"
        }}
      >

        <Table
          style={{ fontSize: "0.9rem", borderRadius: 8, overflow: "hidden" }}
          striped
          bordered
          hover
          responsive
          size="sm"
          variant="dark"
        >
          <thead>
            <tr>
              <th className="text-center">Unidade</th>
              <th className="text-center">PP</th>
            </tr>
          </thead>

          <tbody>
            {units.map((company) => (
              <tr key={company._id} className="text-center">
                <td
                  className="align-middle fw-semibold text-start px-3"
                  style={{ maxWidth: 260 }}
                >
                  <div className="text-truncate" title={company?.name || "--"}>
                    {company?.name || "--"}
                  </div>
                </td>
                <td>
                  <Form.Select
                    id={`company-${company._id}-pp`}
                    size="sm"
                    value={selectedOptions.find(item => item._id === company._id)?.pp ?? 0}
                    onChange={(e) => handleSelectionChange(company._id, e.target.value)}
                    style={{ maxWidth: 120, margin: "0 auto" }}
                    disabled={!permissions?.restricted?.write}
                  >
                    <option value={0}>Desativado</option>
                    <option value={0.5}>0.5</option>
                    <option value={0.75}>0.75</option>
                    <option value={1.0}>1.0</option>
                    <option value={1.25}>1.25</option>
                    <option value={1.5}>1.5</option>
                    <option value={1.75}>1.75</option>
                    <option value={2.0}>2.0</option>
                    <option value={2.25}>2.25</option>
                    <option value={2.4}>2.4</option>
                  </Form.Select>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

      </Modal.Body>
      <Modal.Footer
        className="border-0"
        style={{
          background: "rgba(15, 23, 42, 0.98)",
          color: "#e5e7eb"
        }}
      >
        <Button variant="outline-light" size="sm" onClick={onHide}>
          Fechar
        </Button>
        <Button
          variant="success"
          size="sm"
          onClick={handleSave}
          disabled={!permissions?.restricted?.write}
        >
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MyVerticallyCenteredModal;
